import { takeLatest, put } from 'redux-saga/effects';
import { account as apis } from '../../api';
import { apiSaga } from '../../sagas';
import { push } from 'react-router-redux';
import R from 'ramda';

function* doConfirmEmail({ type, payload }) {
  yield apiSaga(type, apis.confirmEmail, [payload.token]);
}
const sendIntercom = (...params) => {
  if (window.Intercom) {
    window.Intercom(...params); // eslint-disable-line new-cap
  }
};
function* afterConfirmationSuccess({ payload }) {
  sendIntercom('boot', {
    app_id: process.env.INTERCOM_APP,
    user_id: payload.userId,
    email: payload.email,
  });
  sendIntercom('trackEvent', 'Email_Confirmation_Success');
  if (payload.autoLoginToken) {
    yield apiSaga('AUTO_LOGIN', apis.loginAsUser, [{
      ...payload,
      hashToken: payload.autoLoginToken,
    }]);
  } else if (payload.message) {
    yield put(push('/signin'));
    yield put({
      type: 'UPDATE_INFO_BOX',
      messages: {
        [payload.message ? 'signinError' : 'signinInfo']: payload.message,
      },
    });
  }
}

function* afterLoginSuccess({ payload }) {
  localStorage.setItem('jwt', payload.user.jwt);
  const genAiProds = [
    'bookings', 'emailAssist', 'itineraryAssist',
  ];
  const usersAiProds = R.intersection(payload.user.allApps || [], genAiProds);
  if (usersAiProds.length) {
    window.location = `${process.env.NEW_SYSTEM_URL}/generative-ai/${genAiProds[0]}?jwt=${payload.user.jwt}`;
  } else {
    window.location = window.location.origin;
  }
}
export default function* rootSaga() {
  return yield [
    takeLatest('CONFIRM_SIGNIN_EMAIL', doConfirmEmail),
    takeLatest('CONFIRM_SIGNIN_EMAIL_SUCCESS', afterConfirmationSuccess),
    takeLatest('AUTO_LOGIN_SUCCESS', afterLoginSuccess),
  ];
}



// WEBPACK FOOTER //
// ./src/app/stores/sign-in/sign-in-sagas.js